import { UpdateKeyValueRequest } from "@models/base/updateKeyValueRequest.model";

export class UpdateContactoRequest extends UpdateKeyValueRequest {
  public idTipoContacto!: number;
  public valorContacto!: string;
  public preferido!: boolean;
  public empresaAsociada!: string;
  public fechaUltimoContacto!: Date | null;
  public tipoRelacion!: string;
  public fuenteContacto!: string;
  public notasSeguimiento!: string;
  public estadoContacto!: string;
  public categoriasEtiquetas!: string;
  public historialInteracciones!: string;
  public preferenciasContacto!: string;

}
